export enum LegacyExamRequestStatus {
  PendingApproval = 'PENDING_APPROVAL',
  PendingAcceptance = 'PENDING_ACCEPTANCE',
  PendingReassignment = 'PENDING_REASSIGNMENT',
}
